module.exports = __webpack_public_path__ + "img/pilsne.6148182c.svg";